import { Grid, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import styles from './ContactInfo.module.css';

const ContactInfo: FC = () => (
  <Grid className={styles.contact} container>
    <Grid xs={12} sm={6} item>
      <Typography align="center" variant="body2">
        Email:&nbsp;
        <a href="mailto:educators@codesavvy.org" className={styles.email}>
          educators@codesavvy.org
        </a>
      </Typography>
    </Grid>
    <Grid xs={12} sm={6} item>
      <Typography align="center" variant="body2">
        Phone: 612-963-3344
      </Typography>
    </Grid>
  </Grid>
);

export default ContactInfo;
